// functionality to ensure that url parameters follow all internal links
interface Window {
  location: Location;
}

export class UrlParameterTracking {
  private domainsToDecorate: string[];
  private queryParams: string[];

  constructor() {
    // get location href
    const currentDomain = window.location.hostname;
    this.domainsToDecorate = [
      currentDomain, // add or remove domains (without https or trailing slash)
    ];
    this.queryParams = [
      "utm_medium", //add or remove query parameters you want to transfer
      "utm_source",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "gclid",
      "fbclid",
      "ga_client_id",
    ];
    this.init();
  }

  private init() {
    this.decorateLinksForTracking();
    // Set up delayed execution
    setTimeout(() => {
      this.decorateLinksForTracking();
    }, 1000);
  }

  private decorateLinksForTracking() {
    const links = document.querySelectorAll(
      "a"
    ) as NodeListOf<HTMLAnchorElement>;

    // check if links contain domain from the domainsToDecorate array and then decorates
    for (let linkIndex = 0; linkIndex < links.length; linkIndex++) {
      for (
        let domainIndex = 0;
        domainIndex < this.domainsToDecorate.length;
        domainIndex++
      ) {
        if (
          links[linkIndex].href.indexOf(this.domainsToDecorate[domainIndex]) >
            -1 &&
          links[linkIndex].href.indexOf("?") === -1
        ) {
          links[linkIndex].href = this.decorateUrl(links[linkIndex].href);
        }
      }
    }
  }

  // decorates the URL with query params
  private decorateUrl(urlToDecorate: string): string {
    // Extract the hash anchor from the original URL
    const hashIndex = urlToDecorate.indexOf("#");
    let hashAnchor = "";
    if (hashIndex !== -1) {
      hashAnchor = urlToDecorate.substring(hashIndex);
      urlToDecorate = urlToDecorate.substring(0, hashIndex);
    }
    const hasQueryParam = this.queryParams.some((param) =>
      this.getQueryParam(param)
    );

    // Only add query parameters if at least one parameter is present
    const collectedQueryParams = this.queryParams
      .map((param) => {
        const value = this.getQueryParam(param);
        return value ? param + "=" + value : null;
      })
      .filter((param) => param !== null);

    return (
      urlToDecorate +
      (hasQueryParam ? "?" + collectedQueryParams.join("&") : "") +
      hashAnchor
    );
  }

  // borrowed from https://stackoverflow.com/questions/831030/
  // a function that retrieves the value of a query parameter
  private getQueryParam(name: string): string | undefined {
    const match = new RegExp(
      "[?&]" + encodeURIComponent(name) + "=([^&]*)"
    ).exec(window.location.search);
    if (match) {
      return decodeURIComponent(match[1]);
    }
    return undefined;
  }
}

export default function urlParameterTrackingInit() {
  new UrlParameterTracking();
}
